import { useEffect, useState } from "react"
import { UserScheduleContext } from "../context"
import { useFilter } from "../../../hooks/filter"
import { FilterProps } from "../../../hooks/filter/typing"
import { formatFilter } from "../pages/main/constants/filters"
import { removeAllReference } from "../../../utils/methods/removedReference"
import { useGetData } from "../pages/main/hooks/getData"
import { useInput } from "../pages/main/hooks/useInput"
import { Item } from "@/utils/types/generals"

const UserScheduledProvider = (props: { children: JSX.Element }) => {
    const [filterPayload, setFilterPayload] = useState<FilterProps>({ formatFilter: {} })
    const filterData = useFilter(filterPayload)

    const userFilterData = useGetData()

    const { input, disabledInputs } = useInput({ items: userFilterData.items })

    const externalValidation: FilterProps['externalValidation'] = ({
        name,
        value,
        body,
        setFilterData,
    }) => {
        let copyBody: Record<string, any> = removeAllReference(body)

        const currentWeek = name == 'filterByCurrentWeek' ? value : !!body.filterByCurrentWeek
        const openScheduled = name == 'open_scheduled' ? value : !!body.open_scheduled
        let programmed = name == 'programmed' ? value : !!body.programmed

        if (copyBody?.key_codes_origin_st) {
            copyBody = {
                ...copyBody,
                key_codes_origin_st: (copyBody?.key_codes_origin_st as Item[])?.map((item) => ({
                    ...item,
                    value: item.keyCode,
                })),
            }
        }

        if (name === 'areas') {
            const { areas, departments: departmentsData } = copyBody
            const newDepartments = departmentsData?.filter((e: any) =>
                areas.find((e2: any) => e2.value == e.areaId)
            )


            let arrayChilds: any[] = []

            areas?.forEach((e: any) => {
                const id = e.value
                const childs = userFilterData.departments.filter((child) => child.areaId == id)
                arrayChilds.push(...childs)
            })



            userFilterData.handleItemsByExternal({ name: 'departments', value: arrayChilds })
            setFilterData((prev) => ({
                ...prev,
                departments: newDepartments,
            }))

            copyBody = {
                ...copyBody,
                departments: newDepartments,
            }
        } else if (name === 'percentage') {
            if (parseInt(value[0]) === 0 && parseInt(value[1]) === 100) {
                delete copyBody.percentage
            }
        } else if (['filterByCurrentWeek', 'open_scheduled', 'programmed'].includes(name)) {
            disabledInputs({ inputs: ['createYear', 'month', 'from', 'to'], value: !!currentWeek || (!!openScheduled && !programmed) })
        }


        if (name == 'programmed' && programmed && openScheduled) {
            copyBody.open_scheduled = false
            setFilterData((prev) => ({
                ...prev,
                open_scheduled: false,
            }))
        }
        if (name == 'open_scheduled' && programmed && openScheduled) {
            copyBody.programmed = false
            disabledInputs({ inputs: ['createYear', 'month', 'from', 'to'], value: true })
            setFilterData((prev) => ({
                ...prev,
                programmed: false,
            }))
        }
        if (!!currentWeek || !!openScheduled) {
            setFilterData(prev => ({
                ...prev,
                createYear: null,
                month: null,
                from: null,
                to: null,
            }))
            delete copyBody.createYear
            delete copyBody.month
            delete copyBody.from
            delete copyBody.to
        }
        return copyBody
    }

    const userSchedule = useFilter({
        externalValidation,
        formatFilter,
        customeItemQuearyValue: {
            name: ['open_scheduled', 'programmed'],
            transfrom: ({ name, value, body }) => {
                if (name == 'programmed' && (body.open_scheduled === undefined || body.open_scheduled === null)) {
                    return value ? `open_scheduled=false` : ''
                }
                if (name == 'open_scheduled') {
                    if (body.programmed && body.open_scheduled) return ''
                    if (body.programmed) return `open_scheduled=false`
                    if (body.open_scheduled) return `open_scheduled=true`
                    return ``
                }
                return `${name}=${String(value)}`
            }
        }
    })


    return (
        <UserScheduleContext.Provider
            value={{
                filterData, setFilterPayload,
                userSchedule,
                userFilterData,
                input,
                disabledInputs,
            }}
        >
            {props.children}
        </UserScheduleContext.Provider>
    )
}

export { UserScheduledProvider }
